import React from 'react'
import { CountrySelector } from 'submission/components/deal-submission/country-selector'
import {
  INVESTOR_ELIGIBILITY_OPTIONS,
  type EquityFormData,
} from 'submission/lib/equity-form-defaults'

type Props = {
  form: EquityFormData
  setForm: React.Dispatch<React.SetStateAction<EquityFormData>>
  errors: Record<string, string>
}

const VisibilitySection: React.FC<Props> = ({ form, setForm, errors }) => {
  const toggleEligibility = (opt: string) =>
    setForm((p) => ({
      ...p,
      investorEligibility: p.investorEligibility.includes(opt)
        ? p.investorEligibility.filter((x) => x !== opt)
        : [...p.investorEligibility, opt],
    }))

  return (
    <section className="bg-white border border-slate-200 rounded p-6">
      <h2 className="text-lg font-semibold text-slate-900 mb-4">
        Visibility &amp; eligibility
      </h2>
      <div className="flex flex-col gap-3">
        <fieldset>
          <legend className="text-sm text-slate-700 mb-1">Visibility</legend>
          <label className="inline-flex items-center mr-4 text-sm">
            <input
              type="radio"
              name="visibility"
              className="mr-1"
              checked={form.visibility === 'public'}
              onChange={() => setForm((p) => ({ ...p, visibility: 'public' }))}
            />
            Public
          </label>
          <label className="inline-flex items-center text-sm">
            <input
              type="radio"
              name="visibility"
              className="mr-1"
              checked={form.visibility === 'whitelisted'}
              onChange={() =>
                setForm((p) => ({ ...p, visibility: 'whitelisted' }))
              }
            />
            Whitelisted
          </label>
        </fieldset>

        <div>
          <span className="text-sm text-slate-700 mb-1 block">
            Blocked countries
          </span>
          <CountrySelector
            selectedCountries={form.blockedCountries}
            onCountriesChange={(blockedCountries) =>
              setForm((p) => ({ ...p, blockedCountries }))
            }
          />
        </div>

        <fieldset>
          <legend className="text-sm text-slate-700 mb-1">
            Investor eligibility *
          </legend>
          {INVESTOR_ELIGIBILITY_OPTIONS.map((opt) => (
            <label key={opt} className="block text-sm">
              <input
                type="checkbox"
                className="mr-2"
                checked={form.investorEligibility.includes(opt)}
                onChange={() => toggleEligibility(opt)}
              />
              {opt}
            </label>
          ))}
          {errors.investorEligibility && (
            <span className="text-red-600 text-xs mt-1 block">
              {errors.investorEligibility}
            </span>
          )}
        </fieldset>
      </div>
    </section>
  )
}

export default VisibilitySection
